import styled from 'styled-components';
import { Checkbox, mainTheme } from '@plecto/ui';

const DISABLED_OPACITY = 0.5;
const DEFAULT_OPACITY = 1;
// Matches the @plecto/ui dropdown's compact menu row.
const ROW_HEIGHT = 36;

const transition = (...props: string[]) => props
	.map(prop => `${prop} ${mainTheme.motion.duration.default} ${mainTheme.motion.easing.default}`)
	.join(', ');

// The design system's checkbox, not a bare input — it carries its own states.
export const StyledInput = styled(Checkbox).attrs({ size: 'compact' })``;

export const StyledFilterItem = styled.div<{
	$disabled?: boolean;
}>`
	cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
	opacity: ${props => props.$disabled ? DISABLED_OPACITY : DEFAULT_OPACITY};
	align-items: stretch;
	display: flex;
	min-height: ${ROW_HEIGHT}px;
	border-radius: 2px;
	font-weight: 510;
	position: relative;
	color: ${mainTheme.form.dropdown.menu.color};
	transition: ${transition('color')};

	${StyledInput} {
		cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
	}

	// The hover fill lives in the indicator that slides between rows; a row only
	// lifts its own text.
	&:hover {
		color: ${mainTheme.form.dropdown.menu.hover.color};
	}

	&:active {
		color: ${mainTheme.form.dropdown.menu.pressed.color};
	}
`;

export const StyledFilterCustomItem = styled.div`
	align-items: center;
	justify-content: start;
	display: flex;
	min-height: ${ROW_HEIGHT}px;
	padding: 0 8px;
	gap: 8px;
	border-radius: 2px;
	cursor: pointer;
	color: ${mainTheme.form.dropdown.menu.color};
	transition: ${transition('background', 'color')};

	&:hover {
		background: ${mainTheme.form.dropdown.menu.hover.background};
		box-shadow: ${mainTheme.shadow.inset};
		color: ${mainTheme.form.dropdown.menu.hover.color};
	}
`;
